import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBoolean, FctBytes4 } from '../../../../Fct/generics';
export var SupportsInterface = createPlugin({
    protocol: 'ERC1155',
    type: 'GETTER',
    method: 'supportsInterface',
    supportedContracts: undefined,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'erc1155' }),
                methodParams: {
                    interfaceId: new FctBytes4({}),
                },
            },
            output: {
                isSupports: new FctBoolean({ innerIndex: 0 }),
            },
        });
    },
});
